import { useQuery } from "@tanstack/react-query";

import { clusterQuery } from "#modules/cluster/infra/cluster.query";

export const useCluster = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...clusterQuery(id), enabled: !!id });

  return { cluster: data, ...rest };
};
